'use strict';

var RoutingUtil = function ($location, $rootScope, $timeout, $window, $state) {

  var destinationUrl = '';
  var destinationChangeTopLocation = false;

  /**
   * Helper method to save the users original destination
   */
  this.setDestinationUrl = function (url) {
    destinationUrl = url;
  };

  this.setDestinationChangeTopLocation = function (bool) {
    destinationChangeTopLocation = bool;
  };

  this.sendToDestination = function () {
    $rootScope.$applyAsync(function () {
      if (destinationUrl) {
        if (destinationChangeTopLocation) {
          window.top.location.href = destinationUrl;
        }
        else {
          $window.location.href = destinationUrl;
        }

        destinationUrl = '';
      } else {
        if (destinationChangeTopLocation) {
          window.top.location.href = '/';
        } else {
          $location.path('/');
        }
      }
    });
  };

  /**
   * Redirects to a given state on next digest cycle.
   *
   * @param {String} state state to load
   * @param {Object|String} params state toParams
   */
  this.redirectTo = function (state, params) {
    return redirectTo(state, params);
  };

  /**
   * Redirects to 404 (error) page on next digest cycle
   */
  this.redirectTo404 = function () {
    return redirectTo('404');
  };

  /**
   * Redirects to the login page on next digest cycle.
   */
  this.redirectToLogin = function () {
    return redirectTo('login');
  };

  /**
   * Redirects to the logout page which redirects to the login page
   * and clears skydashAuth local storage on next digest cycle.
   */
  this.redirectToLogout = function () {
    $state.go('logout', {}, {
      location: false
    });
  };

  /**
   * Redirects to the specified page on next digest cycle.
   *
   * Normally $state.go by itself should be used but in certain situations (like in
   * $stateProvider resolve or module run) the redirect will not execute so we need to wrap it
   * in a $timeout.
   *
   * @see https://github.com/angular-ui/ui-router/issues/916#issuecomment-36188117
   *
   * @param {String} state
   * @param {Object|String} params state toParams
   */
  function redirectTo (state, params) {

    if (params && typeof params !== 'object') {
      throw new Error('Params must be an object');
    }

    return $timeout(function () {
      $state.go(state, params || {});
    });
  }
};

RoutingUtil.$inject = ['$location', '$rootScope', '$timeout', '$window', '$state'];
module.exports = RoutingUtil;



// WEBPACK FOOTER //
// ./src/common/utils/RoutingUtil.js